// extracted by mini-css-extract-plugin
export var disabled = "_bb-5";
export var fileName = "_bb-b";
export var filePreview = "_bb-4";
export var hoverFilter = "_bb-6";
export var imageButton = "_bb-3 _bb-6";
export var imageButtonContainer = "_bb-2";
export var input = "_bb-7";
export var removeButton = "_bb-0";
export var removeButtonFile = "_bb-1";
export var spinner = "_bb-9";
export var spinnerContainer = "_bb-8";
export var videoContainer = "_bb-a _bb-6";